export { type FromNowProps, default as FromNow } from './FromNow';
